import SubpageLayout from "@components/SubpageLayout";
import Recommendation from "@components/Recommendation";
import styled from "styled-components";
import { useParams } from 'react-router-dom';
import mediaQuery from "@utils/mediaQuery";
import { useEffect } from "react";
import { HealthcareAnalytics, useScrollDepthTracking } from "@utils/analytics";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 36px;

  ${mediaQuery("tablet")`
  align-self: flex-start;
  flex-wrap: wrap;
  gap: 48px;
  `}
`;

const RecommendationPage = () => {
  const { recommendationId } = useParams();

  useEffect(() => {
    const cleanup = useScrollDepthTracking(`recommendation-${recommendationId}`);
    return cleanup;
  }, [recommendationId]);

  useEffect(() => {
    if (recommendationId) {
      HealthcareAnalytics.trackRecommendationView(
        recommendationId, 
        `Recommendation ${recommendationId}`, 
        'unknown'
      );
    }
  }, [recommendationId]);

  return (
    <SubpageLayout
      title="Recommendation"
      subtitle={recommendationId}
    >
      <Container>
        <Recommendation
          id={recommendationId || ""}
          onEdit={() => {}}
          onNewStart={() => {}}
          onRecommendationAvailable={() => {}}
          events={['null']}
        />
      </Container>
    </SubpageLayout>
  );
};

export default RecommendationPage;
